module.exports = __webpack_public_path__ + "img/beneficio-defuncion.43b33eb8.svg";